import React from 'react';

function TwitterSquareIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.9,0C1.3,0,0,1.3,0,2.9v14.3C0,18.7,1.3,20,2.9,20h14.3c1.6,0,2.9-1.3,2.9-2.9V2.9C20,1.3,18.7,0,17.1,0H2.9z M16.1,3.8L11.5,9l5.5,7.2h-4.3l-3.3-4.4l-3.8,4.4H3.4l5-5.7L3.1,3.8h4.4l3,4l3.5-4H16.1z M14.4,15L6.8,5H5.6l7.7,10H14.4L14.4,15z"/>
    </svg>
  );
}

export default TwitterSquareIcon;
